import React,{useEffect} from 'react';
import {
  Box,
  Card,
  CardBody,
  Image,
  Stack,
  Heading,
  Text,
  ButtonGroup,
  Button,
  Flex,
  useColorMode,
  Tooltip,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa'; // Importing icons
import "../../App.css";
import { AboutProjects } from './constants';


const ProjectComponent = ({ projectName, projectGit, projectLive, projectImg, projectIcons, projectDesc }) => {
  const cardStyle = {
    transition: 'transform 0.3s ease-in-out',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
    ':hover': {
      transform: 'scale(1.05)',
    },
    minHeight:['50vh','90vh']
  };

  return (
    <Card maxW={['sm', 'md', 'lg', 'xl']} sx={cardStyle} m="6" borderRadius={"1rem"}>
      <CardBody>
        <Image
          src={projectImg}
          alt='Project Screenshot'
          borderRadius='lg'
          height='290px'
          width='100%'
        />
        <Stack mt='2' spacing='3'>
          <Flex justifyContent='space-between' alignItems='center'>
            <Heading size='lg' fontFamily='Times New Roman'>
              {projectName}
            </Heading>
            <ButtonGroup>
              {
                projectGit===""?(
                  <>

                  </>
                ):(
                  <Tooltip label="See the GitHub Repo!">
                    <Button
                      as="a"
                      href={projectGit}
                      target="_blank"
                      leftIcon={<FaGithub />}
                      colorScheme='purple'
                      variant="ghost"
                      _hover={{ backgroundColor: "purple.900", color: "white" }}
                    >
                    </Button>
                  </Tooltip>
                )
              }
              {
                projectLive===""?(
                  <>
                  </>
                ):(
                  <Tooltip label="See it Live!">
                    <Button
                      as="a"
                      href={projectLive}
                      target="_blank"
                      rightIcon={<FaExternalLinkAlt />}
                      colorScheme='purple'
                      variant="ghost"
                      _hover={{ backgroundColor: "purple.900", color: "white" }}
                    >
                    </Button>
                   </Tooltip>
                )
              }
            </ButtonGroup>
          </Flex>

          <Flex>
            {projectIcons.map((icon, index) => (
              <Image key={index} src={icon} m="2" />
            ))}
          </Flex>
          <Box w="100%" borderBottom="1px solid gray" />
          <Text fontSize={['sm','md']} color={'gray.500'}>
            {projectDesc}
          </Text>
        </Stack>
      </CardBody>
    </Card>
  );
};

const Projects = () => {
 

  const { colorMode } = useColorMode();
  const bgColor = colorMode === "light" ? "white" : "dark";
  const gradientColor = `linear-gradient(135deg, #FF6B6B, #7873F5)`;

  useEffect(()=>{
    window.scrollTo(0,0);
  })

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.5 }}
    >
      <Flex direction="column" align="center" minHeight="100vh" bgColor={bgColor}>  
        {/* Colorful heading */}
        <Heading fontSize={['2xl', '4xl', '7xl']} fontFamily="Times New Roman" textAlign="center">
        <Text
            bgGradient={gradientColor}
            bgClip="text"
            fontFamily={"Times New Roman"}
          >
            My Projects
          </Text>
        </Heading>
        {/* Small paragraph */}
        <Text fontSize={['md', 'lg']} textAlign="center" color="gray.500" mb={8}>
          Explore some of the projects I've built :)
        </Text>
        {/* Project components */}
        <Flex flexWrap="wrap" justify="center" align="center" >
          {AboutProjects.map((about, index) => (
            <ProjectComponent key={index} {...about} />
          ))}
        </Flex>
      </Flex>
      

    </motion.div>
  );
};

export default Projects;
